import { Button, Checkbox, Form, Input } from 'antd';

const wideFormItemProps = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
  labelAlign: 'left' as const,
};

const inputStyle = { width: '100%' };

export function KeyRulesSectionFields() {
  return (
    <>
      <Form.Item name={['keyRulesSection', 'title']} label="Title" {...wideFormItemProps}>
        <Input placeholder="Before You Apply – Key Requirements" style={inputStyle} />
      </Form.Item>
      <Form.Item name={['keyRulesSection', 'intro']} label="Intro" {...wideFormItemProps}>
        <Input.TextArea rows={2} style={inputStyle} />
      </Form.Item>
      <div
        style={{
          margin: '16px',
        }}
      >
        <Form.List name={['keyRulesSection', 'rules']}>
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, index) => (
                <div
                  key={field.key}
                  style={{
                    border: '1px solid #e2e8f0',
                    borderRadius: 8,
                    padding: 16,
                    marginBottom: 12,
                    background: '#fafbfc',
                  }}
                >
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}
                  >
                    <p style={{ fontWeight: 600, margin: 0 }}>Rule {index + 1}</p>
                    {fields.length > 1 && (
                      <Button danger size="small" onClick={() => remove(field.name)}>
                        Remove
                      </Button>
                    )}
                  </div>
                  <Form.Item
                    {...field}
                    name={[field.name, 'title']}
                    label="Title"
                    {...wideFormItemProps}
                    rules={[{ required: true, message: 'Rule title is required' }]}
                  >
                    <Input style={inputStyle} />
                  </Form.Item>
                  <Form.Item
                    {...field}
                    name={[field.name, 'text']}
                    label="Description"
                    {...wideFormItemProps}
                    rules={[{ required: true, message: 'Rule description is required' }]}
                  >
                    <Input.TextArea rows={3} style={inputStyle} />
                  </Form.Item>
                  <Form.Item
                    {...field}
                    name={[field.name, 'featured']}
                    valuePropName="checked"
                    label="Featured"
                    {...wideFormItemProps}
                  >
                    <Checkbox>Highlight this rule</Checkbox>
                  </Form.Item>
                </div>
              ))}
              <Form.Item wrapperCol={{ span: 12, offset: 4 }}>
                <Button
                  type="dashed"
                  onClick={() => add({ title: '', text: '', featured: false })}
                  style={{ color: '#637f92', fontWeight: 600 }}
                >
                  + Add Rule
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </div>
    </>
  );
}

export function FeesSectionFields() {
  return (
    <>
      <p style={{ marginLeft: '25px', marginTop: '14px', color: '#64748b' }}>
        <span
          style={{
            display: 'inline-block',
            width: '8px',
            height: '8px',
            backgroundColor: '#64748b',
            borderRadius: '50%',
            marginRight: '8px',
          }}
        />{' '}
        Optional — leave empty to hide Service Fees on the frontend.
      </p>
      <Form.Item name={['feesSection', 'title']} label="Title" {...wideFormItemProps}>
        <Input placeholder="OCI fees" style={inputStyle} />
      </Form.Item>
      <Form.Item name={['feesSection', 'feeIntro']} label="Intro" {...wideFormItemProps}>
        <Input.TextArea rows={2} style={inputStyle} />
      </Form.Item>
      <Form.Item
        name={['feesSection', 'feeHeader', 0]}
        label="Table Header (Left)"
        {...wideFormItemProps}
      >
        <Input placeholder="Fee Type" style={inputStyle} />
      </Form.Item>
      <Form.Item
        name={['feesSection', 'feeHeader', 1]}
        label="Table Header (Right)"
        {...wideFormItemProps}
      >
        <Input placeholder="Amount (CAD)" style={inputStyle} />
      </Form.Item>
      <Form.List name={['feesSection', 'fees']}>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => (
              <Form.Item key={field.key} label={`Fee Row ${index + 1}`} {...wideFormItemProps}>
                <div style={{ display: 'flex', gap: 8, width: '100%', height: '35px' }}>
                  <Form.Item
                    {...field}
                    name={[field.name, 'label']}
                    style={{ flex: 1, marginBottom: 0, padding: 0, border: 'none' }}
                  >
                    <Input placeholder="OCI government fee" />
                  </Form.Item>
                  <Form.Item
                    {...field}
                    name={[field.name, 'amount']}
                    style={{ width: 140, marginBottom: 0, padding: 0, border: 'none' }}
                  >
                    <Input placeholder="$345" />
                  </Form.Item>
                  <Form.Item
                    {...field}
                    name={[field.name, 'note']}
                    style={{ flex: 1, marginBottom: 0, padding: 0, border: 'none' }}
                  >
                    <Input placeholder="Optional note" />
                  </Form.Item>
                  <Button danger onClick={() => remove(field.name)}>
                    Remove
                  </Button>
                </div>
              </Form.Item>
            ))}
            <Form.Item wrapperCol={{ span: 12, offset: 4 }}>
              <Button
                type="dashed"
                onClick={() => add({ label: '', amount: '', note: '' })}
                style={{ color: '#637f92', fontWeight: 600 }}
              >
                + Add Fee Row
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
      <Form.Item name={['feesSection', 'feeTotalLabel']} label="Total Label" {...wideFormItemProps}>
        <Input placeholder="Total estimated" style={inputStyle} />
      </Form.Item>
      <Form.Item name={['feesSection', 'feeTotal']} label="Total Amount" {...wideFormItemProps}>
        <Input placeholder="$348 + service charges" style={inputStyle} />
      </Form.Item>
    </>
  );
}

export function RelatedServicesSectionFields() {
  return (
    <>
      <Form.Item name={['relatedServicesSection', 'title']} label="Title" {...wideFormItemProps}>
        <Input placeholder="Related Services" style={inputStyle} />
      </Form.Item>
      <Form.Item
        name={['relatedServicesSection', 'subtitle']}
        label="Subtitle"
        {...wideFormItemProps}
      >
        <Input.TextArea rows={2} style={inputStyle} />
      </Form.Item>
      <Form.List name={['relatedServicesSection', 'links']}>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => (
              <Form.Item
                key={field.key}
                label={`Service ${index + 1}`}
                {...wideFormItemProps}
                required
              >
                <div
                  style={{
                    display: 'flex',
                    gap: 8,
                    width: '100%',
                    height: '35px',
                  }}
                >
                  <Form.Item
                    {...field}
                    name={[field.name, 'name']}
                    rules={[{ required: true, message: 'Service name required' }]}
                    style={{ flex: 1, marginBottom: 0, padding: 0, border: 'none' }}
                  >
                    <Input placeholder="Service name" />
                  </Form.Item>
                  <Form.Item
                    {...field}
                    name={[field.name, 'link']}
                    rules={[{ required: true, message: 'Link required' }]}
                    style={{ flex: 1, marginBottom: 0, padding: 0, border: 'none' }}
                  >
                    <Input placeholder="https://documitra.com/..." />
                  </Form.Item>
                  <Button danger onClick={() => remove(field.name)}>
                    Remove
                  </Button>
                </div>
              </Form.Item>
            ))}
            <Form.Item wrapperCol={{ span: 12, offset: 4 }}>
              <Button
                type="dashed"
                onClick={() => add({ name: '', link: '' })}
                style={{ color: '#637f92', fontWeight: 600 }}
              >
                + Add Related Service
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </>
  );
}

export function BenefitsSectionFields() {
  return (
    <>
      <p style={{ marginLeft: '25px', marginTop: '14px', color: '#64748b' }}>
        <span
          style={{
            display: 'inline-block',
            width: '8px',
            height: '8px',
            backgroundColor: '#64748b',
            borderRadius: '50%',
            marginRight: '8px',
          }}
        />{' '}
        Optional — leave empty to hide Service Fees on the frontend.
      </p>
      <Form.Item name={['benefitsSection', 'title']} label="Title" {...wideFormItemProps}>
        <Input placeholder="What an OCI card gives you" style={inputStyle} />
      </Form.Item>
      <Form.Item name={['benefitsSection', 'subtitle']} label="Subtitle" {...wideFormItemProps}>
        <Input.TextArea rows={2} placeholder="Optional section description" style={inputStyle} />
      </Form.Item>
      <div
        style={{
          margin: '16px',
          padding: '16px',
          border: '1px solid #e2e8f0',
          borderRadius: 8,
          background: '#fafbfc',
        }}
      >
        <Form.List name={['benefitsSection', 'benefits']}>
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, index) => (
                <Form.Item key={field.key} label={`Benefit ${index + 1}`} {...wideFormItemProps}>
                  <div style={{ display: 'flex', gap: 8, width: '100%' }}>
                    <Form.Item
                      {...field}
                      style={{ flex: 1, marginBottom: 0, padding: 0, border: 'none' }}
                    >
                      <Input placeholder="e.g. Lifelong stay in India" />
                    </Form.Item>
                    <Button danger onClick={() => remove(field.name)}>
                      Remove
                    </Button>
                  </div>
                </Form.Item>
              ))}
              <Form.Item wrapperCol={{ span: 12, offset: 4 }}>
                <Button
                  type="dashed"
                  onClick={() => add('')}
                  style={{ color: '#637f92', fontWeight: 600 }}
                >
                  + Add Benefit Tag
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </div>
    </>
  );
}

/** @deprecated Prefer the separate section components wrapped in their own Accordian. */
export default function PackageExtrasSectionFields() {
  return (
    <>
      <KeyRulesSectionFields />
      <FeesSectionFields />
      <BenefitsSectionFields />
      <RelatedServicesSectionFields />
    </>
  );
}
